/** @jsx h */
import { h } from 'preact'
import Scheme from './Scheme'
import Facilities from './Facilities'
import Unrecyclable from './Unrecyclable'
import Error from './Error'

const Results = ({ results, error, hideTopBorder = false }) => {
  const containerClass = hideTopBorder ? 'RecyclingResults RecyclingResults--noBorder' : 'RecyclingResults'

  if (results == null) {
    if (error == null) {
      return null
    } else {
      console.log(error)
      return (
        <section class={containerClass}>
          <Error />
        </section>
      )
    }
  }

  const { scheme, facilities, unrecyclable } = results

  return (
    <section class={containerClass}>
      <Scheme {...scheme} />
      <Facilities facilities={facilities} />
      <Unrecyclable {...unrecyclable} />
    </section>
  )
}

export default Results
